// src/pages/PoliticaPrivacidad.jsx
import LegalShell from "./LegalShell";

export default function PoliticaPrivacidad() {
  return (
    <LegalShell
      eyebrow="Proteccion de datos personales"
      title="Politica de Privacidad y Tratamiento de Datos"
      intro="Esta politica describe como ECONFIA recolecta, usa, almacena, comparte y protege los datos personales de sus usuarios y de los titulares consultados, en cumplimiento de la Ley 1581 de 2012, la Ley 1266 de 2008 y demas normas aplicables en Colombia."
      updatedAt="7 de septiembre de 2026"
    >
      <section>
        <h2>1. Responsable del tratamiento</h2>
        <p>
          El responsable del tratamiento de los datos personales es la empresa
          operadora de la plataforma ECONFIA, con domicilio en Bogota D.C.,
          Colombia. Para cualquier asunto relacionado con esta politica o con el
          ejercicio de sus derechos, puede contactarnos en:
        </p>
        <ul>
          <li>
            Correo:{" "}
            <a href="mailto:coordinaciondesarrollo@solutionsgroupcol.com">
              coordinaciondesarrollo@solutionsgroupcol.com
            </a>
          </li>
          <li>Telefono / WhatsApp: +57 305 422 6582</li>
          <li>Ciudad: Bogota D.C., Colombia</li>
        </ul>
      </section>

      <section>
        <h2>2. Datos que recolectamos</h2>
        <p>
          Segun el uso que haga de la aplicacion, ECONFIA puede recolectar las
          siguientes categorias de datos:
        </p>
        <h3>2.1 Datos de la cuenta del usuario</h3>
        <ul>
          <li>Nombre y apellidos.</li>
          <li>Correo electronico y numero de contacto.</li>
          <li>Credenciales de acceso (almacenadas de forma cifrada).</li>
          <li>Datos de la organizacion o empresa, cuando aplique.</li>
        </ul>
        <h3>2.2 Datos de las consultas</h3>
        <ul>
          <li>
            Numero de identificacion (cedula, NIT u otro documento) de la persona
            o entidad que el usuario decide consultar.
          </li>
          <li>Nombres y demas datos necesarios para realizar la verificacion.</li>
          <li>Historial de consultas realizadas dentro de la cuenta.</li>
        </ul>
        <h3>2.3 Datos tecnicos</h3>
        <ul>
          <li>
            Informacion del dispositivo, tipo de navegador o sistema operativo.
          </li>
          <li>
            Direccion IP, fecha y hora de acceso, y registros de uso con fines de
            seguridad.
          </li>
        </ul>
        <p>
          ECONFIA no solicita ni almacena informacion de tarjetas de credito o
          datos bancarios dentro de la aplicacion; los pagos, cuando existan, se
          procesan a traves de pasarelas de pago externas y seguras.
        </p>
      </section>

      <section>
        <h2>3. Finalidades del tratamiento</h2>
        <p>Los datos se tratan para las siguientes finalidades:</p>
        <ul>
          <li>Crear y administrar la cuenta del usuario.</li>
          <li>
            Prestar el servicio de consulta y verificacion en fuentes publicas,
            abiertas, oficiales o de terceros legalmente habilitados, para
            procesos de debida diligencia, conocimiento de contrapartes, gestion
            del riesgo y cumplimiento normativo (SARLAFT, SAGRILAFT, SIPLAFT y
            LA/FT/FPADM).
          </li>
          <li>Generar reportes y evidencias de las consultas realizadas.</li>
          <li>Garantizar la seguridad de la plataforma y prevenir fraudes.</li>
          <li>Atender solicitudes, consultas y reclamos.</li>
          <li>Cumplir obligaciones legales o regulatorias aplicables.</li>
        </ul>
      </section>

      <section>
        <h2>4. Naturaleza de la informacion consultada</h2>
        <p>
          La informacion obtenida a traves de ECONFIA proviene de fuentes
          publicas, abiertas, oficiales o de terceros legalmente habilitados. Su
          caracter es referencial, informativo y de apoyo para analisis de
          riesgo, por lo que no constituye por si sola una declaracion definitiva
          de responsabilidad sobre las personas o entidades consultadas. ECONFIA
          no garantiza que dicha informacion este libre de errores o totalmente
          actualizada, ya que depende de la disponibilidad de las fuentes de
          origen.
        </p>
      </section>

      <section>
        <h2>5. Autorizacion y responsabilidad del usuario</h2>
        <p>
          El usuario declara que cuenta con la base legal y/o la autorizacion
          correspondiente para realizar las consultas, y se obliga a usar la
          informacion unicamente para fines licitos y autorizados, absteniendose
          de divulgarla, comercializarla o reutilizarla de forma no autorizada.
          El uso indebido de la informacion es responsabilidad exclusiva del
          usuario.
        </p>
      </section>

      <section>
        <h2>6. Con quien se comparte la informacion</h2>
        <p>
          ECONFIA no vende ni cede datos personales a terceros con fines
          comerciales. La informacion puede compartirse unicamente con:
        </p>
        <ul>
          <li>
            Proveedores tecnologicos que apoyan la operacion de la plataforma
            (alojamiento, seguridad, mensajeria), bajo obligaciones de
            confidencialidad.
          </li>
          <li>
            Autoridades competentes, cuando exista una obligacion legal o
            requerimiento judicial o administrativo valido.
          </li>
        </ul>
      </section>

      <section>
        <h2>7. Conservacion de los datos</h2>
        <p>
          Los datos se conservan durante el tiempo necesario para cumplir las
          finalidades descritas y las obligaciones legales aplicables. Una vez
          cumplidas dichas finalidades, los datos son eliminados o anonimizados de
          forma segura, salvo cuando deban conservarse por disposicion legal.
        </p>
      </section>

      <section>
        <h2>8. Seguridad de la informacion</h2>
        <p>
          ECONFIA adopta medidas tecnicas, administrativas y organizacionales
          razonables para proteger la informacion frente a accesos no
          autorizados, perdida, alteracion o uso indebido, incluyendo cifrado de
          credenciales, conexiones seguras (HTTPS) y controles de acceso.
        </p>
      </section>

      <section>
        <h2>9. Derechos del titular (Habeas Data)</h2>
        <p>
          De acuerdo con la Ley 1581 de 2012, el titular de los datos tiene
          derecho a:
        </p>
        <ul>
          <li>Conocer, actualizar y rectificar sus datos personales.</li>
          <li>Solicitar prueba de la autorizacion otorgada, cuando aplique.</li>
          <li>Ser informado sobre el uso dado a sus datos.</li>
          <li>
            Presentar quejas ante la Superintendencia de Industria y Comercio por
            infracciones a la normativa.
          </li>
          <li>
            Revocar la autorizacion y/o solicitar la supresion de los datos cuando
            no exista un deber legal o contractual de conservarlos.
          </li>
          <li>Acceder de forma gratuita a sus datos personales.</li>
        </ul>
      </section>

      <section>
        <h2>10. Como ejercer sus derechos</h2>
        <p>
          El titular o su representante puede ejercer estos derechos enviando una
          solicitud al correo{" "}
          <a href="mailto:coordinaciondesarrollo@solutionsgroupcol.com">
            coordinaciondesarrollo@solutionsgroupcol.com
          </a>
          , indicando su nombre, documento de identidad, el derecho que desea
          ejercer y los datos de contacto. Las consultas se atienden en un termino
          maximo de diez (10) dias habiles y los reclamos en un termino maximo de
          quince (15) dias habiles, conforme a la ley.
        </p>
      </section>

      <section>
        <h2>11. Datos de menores de edad</h2>
        <p>
          La aplicacion esta dirigida a usuarios mayores de edad que actuan en el
          marco de procesos de verificacion y cumplimiento. No recolectamos de
          forma consciente datos de menores de edad como usuarios del servicio.
        </p>
      </section>

      <section>
        <h2>12. Eliminacion de la cuenta y de los datos</h2>
        <p>
          El usuario puede solicitar la eliminacion de su cuenta y de sus datos
          personales escribiendo a{" "}
          <a href="mailto:coordinaciondesarrollo@solutionsgroupcol.com">
            coordinaciondesarrollo@solutionsgroupcol.com
          </a>
          . Procederemos con la eliminacion salvo la informacion que debamos
          conservar por obligaciones legales.
        </p>
      </section>

      <section>
        <h2>13. Cambios en esta politica</h2>
        <p>
          ECONFIA podra actualizar esta politica cuando existan cambios
          normativos, operativos o tecnologicos. La version vigente sera la
          publicada en este sitio, con su respectiva fecha de actualizacion.
        </p>
      </section>

      <section>
        <h2>14. Ley aplicable</h2>
        <p>
          Esta politica se rige por la Constitucion Politica de Colombia (articulo
          15), la Ley 1581 de 2012, la Ley 1266 de 2008, el Decreto 1377 de 2013 y
          demas normas concordantes.
        </p>
      </section>
    </LegalShell>
  );
}
